import React from 'react';
import localize from '../../components/localize';

import './Location.css'

const LocationBare = ({ i18n, location, hideCountry }) => (
	<span className="location-text">{
		hideCountry?
		i18n.t('location').split(', ').filter(c => c === '!city' || c === '!region').join(', ').replace('!city', location.city).replace('!region', location.region) :
		i18n.replace('location', { '!city': location.city, '!region': location.region, '!country': i18n.country(location.country_code) })
	}</span>
);

export default localize()(LocationBare);



// WEBPACK FOOTER //
// ./src/components/Location/index.js